// extracted by mini-css-extract-plugin
export default {"fallback_svg":"fallback_svg___R1F_Q"};